import React from 'react';
import { useSelector } from 'react-redux';
import { InsertImageComponent } from 'app/views/components/editor/tools/insert/InsertImage';
const ToolInsertComponent = {
    image: InsertImageComponent,
};
export const MarkerInsert = () => {
    const activeTool = useSelector((state) => state.editor.activeTool);
    const Component = activeTool ? ToolInsertComponent[activeTool] : null;
    if (Component) {
        return React.createElement(Component, null);
    }
    return null;
};
